import type { Locale } from '@fv/models'

import { useAppSettings } from './useAppSettings'

export function useLocale(): Locale {
  const settingsQuery = useAppSettings()
  return settingsQuery.data?.locale ?? 'en-US'
}
